import React, { useState, useEffect } from 'react';
import { Divider } from 'antd';
import { useNavigate } from 'react-router-dom';
import './GSADashboard.scss';
import { sessionServices } from '../../../Utils/SessionServices.js';
import { FundraiserServices } from '../../../Services/API/fundraisersService';
import Loader from '../../../Components/Loader/Loader';
import { idExtractor } from '../../../Utils/Split.js'
import { formatAmount } from '../../../Utils/constants.js';

export default function Dashboard() {
    const navigate = useNavigate();
    const [loader, setLoader] = useState(true);
    const [role, setRole] = useState("");
    const [activeFundraisers, setActiveFundraisers] = useState([]);

    useEffect(() => {
        getRole();
    }, []);

    useEffect(() => {
        if (role) {
            getFundraisers();
        }
    }, [role]);

    const getRole = () => {
        sessionServices
            .getSessionStorageItem("role")
            .then((res) => {
                setRole(res);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    function getFundraisers() {
        FundraiserServices.getActiveFundraisers(role)
            .then((response) => {
                setActiveFundraisers(response?.data);
                setLoader(false)
            })
            .catch((err) => console.log(err))
    }

    const handleNavigateSingleFundraiser = (Id) => {
        let temp = idExtractor(Id, '/')
        navigate(`/fundraiser/${temp[temp?.length - 1]}`)
    }

    if (loader) {
        return (
            <Loader />
        )
    } else {
        return (
            <div className="Dashboard-container">
                <div className="GSA-dash-first-row">
                    <div className="first-row-header-container">
                        <div className="heading">Active Fundraisers</div>
                    </div>
                    <div className="active-fundraisers-component">
                        <div className="individual-fund">
                            <div className="fund-info grid-heading">Fundraiser Name</div>
                            <div className="fund-info grid-heading">Location</div>
                            <div className="fund-info grid-heading">Funds Raised</div>
                            <div className="fund-info grid-heading">Target</div>
                        </div>
                        {activeFundraisers.length > 0 ?
                            activeFundraisers?.map((fund, i) => {
                                return (
                                    <>
                                        <Divider className='active-funds-divider' dashed />
                                        <div className="individual-fund">
                                            <div className="fund-info cursor" onClick={() => handleNavigateSingleFundraiser(fund?.id)}>{fund?.title}</div>
                                            <div className="fund-info">{fund?.location}</div>
                                            <div className="fund-info amount">{formatAmount(fund?.total_raised)}</div>
                                            <div className="fund-info amount">{formatAmount(fund?.goal)}</div>
                                        </div>
                                    </>
                                )
                            })
                            : (
                                <div className="no-data">No active fundraisers now</div>
                            )}
                    </div>
                </div>
                <div className="GSA-dash-second-row"></div>
            </div>
        )
    }
}
